import React from 'react'
import PropTypes from 'prop-types'
import LinkChooser from '../links/linkChooser'

import s from './button.module.css'

const themes = {
  size: {
    big: s.big,
    medium: s.medium,
    small: s.small,
  },
  color: {
    orange: s.orange,
    white: s.white,
    transparent: s.transparent,
    whiteFlat: s.whiteFlat,
    outlineWhite: s.outlineWhite,
    outlineRed: s.outlineRed,
    outlineTurquoise: s.outlineTurquoise,
    turquoise: s.turquoise,
    yellow: s.yellow
  },
}

const Btn = props => {
  if (['button', 'submit'].includes(props.type)) {
    return (
      <button
        id={props.id ? props.id : undefined}
        className={`
          ${props.isPill ? s.pill : ''}
          ${s.button}
          ${themes.size[props.size]}
          ${themes.color[props.color]}
          ${props.className}
          ${props.disabled ? s.orangeDisabled : ''}
        `}
        onClick={props.onClick}
        disabled={props.disabled}
        type={props.type}
        {...props.attributes}
      >
        {props.label}
      </button>
    )
  } else if (props.type === 'link') {
    return (
      <ButtonWrapper
        size={props.size}
        isPill={props.isPill}
        color={props.color}
        wrapClass={props.wrapClass}
        className={props.className}
      >
        <LinkChooser
          id={props.id ? props.id : undefined}
          onClick={props.onClick}
          to={props.href}
        >
          {props.label}
        </LinkChooser>
      </ButtonWrapper>
    )
  }
}

const ButtonWrapper = props => (
  <div
    className={` ${props.isPill ? s.pill : ''} ${s.button} ${
      themes.size[props.size]
    } ${themes.color[props.color]} ${props.className}`}
  >
    {props.children}
  </div>
)

Btn.defaultProps = {
  type: 'link',
  color: 'orange',
  size: 'big',
  id: false,
  style: 'solid',
  isPill: false,
  className: '',
  href: '/',
}

Btn.propTypes = {
  type: PropTypes.oneOf(['gatsby-link', 'button', 'link', 'submit']),
  color: PropTypes.oneOf([
    'orange',
    'white',
    'whiteFlat',
    'outlineWhite',
    'outlineRed',
    'transparent',
    'outlineTurquoise',
    'turquoise',
    'yellow'
  ]),
  size: PropTypes.oneOf(['big', 'small', 'medium']),
}

export default Btn
